import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    picked_up: 0
  },
  mutations: {
    //servidor
    SOCKET_PICKED_UP(state, payload) {
      state.picked_up = payload;
    }
  },
  actions: {
    // cliente
  },
  modules: {
  }
})
